import Navigation from '@/components/navigation/Navigation'
import MyIdicare from '@/components/page/MyIdicare'
import AppShell from '@/components/shell/AppShell'

export default [
	{
		path: '/:user_uid',
		meta: {
			requiredAuth: true
		},
		components: {
			default: AppShell
		},
		props: {
			default: true
		},
		children: [
			{
				path: 'my-idicare',
				name: 'MyIdicare',
				components: {
					default: MyIdicare,
					menu: Navigation
				},
				props: {
					default: true,
					menu: true
				}
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/user/myidicare.js